/* eslint-disable @1js/office-online-rules/no-v8-imports-for-fluentui */
import type { IKeytipProps } from "@fluentui/react";
import { memoizeFunction } from "@fluentui/react";

import { defaultOnReturn } from "@1js/acui-keytip";
import { getBoundingWindowWithPaddingFabric } from "@1js/window-util";

const itemInMenuOffset = { x: 19, y: 17 }; // When in a menu, keytip should be positioned 19px from the left and 17px from the top

export const deriveMenuKeytip = memoizeFunction(
  (
    keytipProps?: IKeytipProps,
    onExecute?: (executeTarget: HTMLElement) => void
  ): IKeytipProps | undefined => {
    if (keytipProps) {
      return {
        offset: itemInMenuOffset,
        ...keytipProps,
        onExecute,
        onReturn: defaultOnReturn,
        calloutProps: {
          gapSpace: 0,
          ...keytipProps.calloutProps,
          bounds: getBoundingWindowWithPaddingFabric,
        },
      };
    }
    return undefined;
  }
);
